import { FormHandle } from '@/hooks/use-form-handle.hook';
import { FC, useState } from 'react';
import InputControl from '@/components/form/input-control';
import { isWriteMode, ViewMode } from '@/lib/helpers';
import { Box } from '@mui/material';
import { ConnectorModel } from '@/lib/models/connector/connector.model';
import { AzureFoundryConnectorModel } from '@/lib/models/connector/azure-foundry-connector.model';
import { getTypedConnector } from '@/lib/models/connector';
import TextInput from '@/components/form/text-input';

interface Props {
  connector: AzureFoundryConnectorModel;
  formHandle: FormHandle<ConnectorModel>;
  mode: ViewMode;
}

const AzureFoundryConnector: FC<Props> = ({ formHandle, mode, connector }) => {
  const inWriteMode = isWriteMode(mode);
  const isNew = !connector.id;

  const { projectEndpoint: propProjectEndpoint } = getTypedConnector(
    connector
  ) as AzureFoundryConnectorModel;
  const [projectEndpoint, setProjectEndpoint] = useState<string>(propProjectEndpoint);
  const [projectEndpointError, setProjectEndpointError] = useState('');

  const { setFieldValue } = formHandle;

  const handleChangeProjectEndpoint = (val: string) => {
    setProjectEndpoint(val);
    const projectEndpoint = AzureFoundryConnectorModel.parseProjectEndpointUrl(val);

    if (!projectEndpoint) {
      setFieldValue('config.resourceName', '');
      setFieldValue('config.projectName', '');
      setProjectEndpointError(
        'Enter a project endpoint in the format https://<resource>.services.ai.azure.com/api/projects/<project>'
      );
      return;
    }

    const { resourceName, projectName } = projectEndpoint;
    setFieldValue('config.resourceName', resourceName);
    setFieldValue('config.projectName', projectName);
    setProjectEndpointError('');
  };

  if (!inWriteMode) {
    return null;
  }

  return (
    <Box>
      <InputControl
        name="config.apiKey"
        label="API Key"
        formHandle={formHandle}
        updateOnly={!isNew}
        required
      />

      <TextInput
        name="projectEndpoint"
        label="Project Endpoint"
        value={projectEndpoint}
        onChange={handleChangeProjectEndpoint}
        error={projectEndpointError}
        required
      />

      <InputControl
        name="config.resourceName"
        label="Resource name"
        formHandle={formHandle}
        disabled
        readonly
      />

      <InputControl
        name="config.projectName"
        label="Project name"
        formHandle={formHandle}
        disabled
        readonly
      />
    </Box>
  );
};

export default AzureFoundryConnector;
